import React from 'react';
import { FormattedMessage } from 'react-intl';

import ItemDisplayImage from '../../../components/line-item/components/item-image.component';
import messages from '../messages';
import style from './style.module.less';

const name = <FormattedMessage {...messages.thumbnailUrlColumnHeader} />;

export default {
  getMessageDescriptor: () => messages.thumbnailUrlColumnHeader,
  name,
  render: (data) => <ItemDisplayImage className={style.image} productThumbnailUrl={data.thumbnailUrl} shouldShowNoImageIcon={false} />,
};
